import React from 'react'

import Context from 'ansok/services/Context'
import { ContextType } from 'ansok/types'
import { PartialType } from 'types'

function withContext(
  Component: React.ComponentType | React.ElementType,
  contextFilter?: (value: ContextType) => PartialType<ContextType>,
) {
  return function(props) {
    return (
      <Context.Consumer>
        {(value: ContextType) => <Component {...value} {...props} />}
      </Context.Consumer>
    )
  }
}

export { withContext, ContextType as WithContextProps }
